A plain text summary of how payment will be broken down across payment methods.

This is a human-readable string intended for displaying in a user interface.
